import React, { useEffect } from 'react';
import saveAs from 'file-saver';
import _ from 'lodash';
import { setProcedureList } from 'src/reducers/procedures/procedures';
import { setGlobalErrors } from 'src/reducers/global';
import { setClientBonusList } from 'src/reducers/clients/clientBonus';
import { USER_LOGIN } from 'src/constants/EndpointUrls';
import { redirectTo } from 'src/utils/Http';
import { isRoleTypeAdmin, isRoleTypeEmployee, isRoleTypeOperator } from 'src/reducers/users/currentUser';
import AdminDashboard from './AdminDashboard';
import EmployeeDashboard from './EmployeeDashboard';

const Dashboard = ({ dispatch, currentUser, planType, values }) => {
  const {
    systemAnnounces,
    mostRecentNotConfirmedSalary,
    todayMemos,
    notCompletedSetting,
    notCompletedProcedures,
    notCompletedBonusPaymentNotification,
    employeeAnnounces,
    downloadPath,
    numberEmployees,
    expensesSummary,
    employeeCategories,
    monthlyExpenseSummary,
    expensesSummaryYearList,
    memos
  } = values;

  useEffect(() => {
    const fetchData = async () => {
      if (!_.isNull(downloadPath)) {
        const headers = { 'X-Requested-With': 'XMLHttpRequest' };
        const response = await fetch(downloadPath, { headers });
        if (!response.ok) {
          const json = await response.json();
          dispatch(setGlobalErrors(json.errors.messages));
        } else {
          const responseBlob = await response.blob();
          const blob = new Blob([responseBlob], { type: 'text/csv' });
          const fileName = decodeURI(response.headers.get('content-disposition').match(/filename="(.*)"/)[1]);
          saveAs(blob, fileName);
        }
      }
    };

    fetchData();
  }, []);

  dispatch(setProcedureList(notCompletedProcedures));
  dispatch(setClientBonusList({ data: notCompletedBonusPaymentNotification }));

  if (!currentUser.isAuthorized) {
    redirectTo(USER_LOGIN);
  }

  return (
    <div>
      {(isRoleTypeAdmin(currentUser.roleType) || isRoleTypeOperator(currentUser.roleType)) && (
        <AdminDashboard
          currentUser={currentUser}
          {...{
            systemAnnounces,
            mostRecentNotConfirmedSalary,
            notCompletedSetting,
            todayMemos,
            planType,
            numberEmployees,
            expensesSummary,
            employeeCategories,
            monthlyExpenseSummary,
            expensesSummaryYearList,
            memos
          }}
        />
      )}
      {isRoleTypeEmployee(currentUser.roleType) && <EmployeeDashboard employeeAnnounces={employeeAnnounces} />}
    </div>
  );
};
export default Dashboard;
